import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerTrashProps = {
  component: object;
  packageFile?: string;
  range?: object;
  safeCommitHash?: string;
  safeVersion?: string;
  transitive?: boolean;
  unsafeCommitHash?: string;
  unsafeVersion?: string;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerTrash: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerTrashProps
> = props => {
  const {
    component,
    transitive = false,
    range,
    safeCommitHash,
    unsafeCommitHash,
    packageFile = 'vendor.conf',
    safeVersion,
    unsafeVersion,
  } = props;
  const { name } = component;
  const unsafeVersionText =
    unsafeVersion ||
    (range.versionRange && range.versionRange.indexOf('-') !== -1
      ? range.versionRange.split('-')[0]
      : '');
  const unsafeCommitHashText =
    unsafeCommitHash || (range.versionRange === 'HEAD' ? range.endCommit : '');
  const diff = (
    <div className="grid bo--1 border-color--white-dark mt lh+ bg-color--white">
      <ArtifactViewCodeDiffHeader text={packageFile} />
      <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
      <ArtifactViewCodeDiffDisplay
        type="delete"
        text={`${component.coordinate1} ${unsafeCommitHashText || unsafeVersionText}`}
      />
      <ArtifactViewCodeDiffDisplay
        type="add"
        text={`${component.coordinate1} ${safeCommitHash || safeVersion}`}
      />
      <ArtifactViewCodeDiffDisplay type="normal" text={'\u2003\u00B7\u00B7\u00B7'} />
    </div>
  );
  return (
    <div className="pt-">
      <div className="grid pt">
        {!transitive && (
          <span className="ph-- pv-">
            {' '}
            Update your <span className="text--bold"> {packageFile} </span>
          </span>
        )}
        {transitive && (
          <span className="ph-- pv-">
            {' '}
            Include {name} to your <span className="text--bold">{packageFile}</span>
          </span>
        )}
        <span className="pv-">as shown below:</span>
      </div>
      {diff}
      <div className="grid pt">
        <span className="grid__item pv- pl--">
          After updating {packageFile}, type the following to perform update. This will also update
          other libraries in {packageFile}
        </span>
      </div>
      <div className="pt-- -ml mt-">
        <span className="font-family--code bg-color--white-medium p-">trash</span>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerTrash;
